var $j = jQuery.noConflict();
var urlWhatsapp = '';

function getShopifyProductTitle() {
  const metaProductTitle = window?.meta?.product?.title;
  if (metaProductTitle) return String(metaProductTitle).trim();

  const productTitleElement = document.querySelector(
    'h1.product__title, h1.product-single__title, .product__title, [data-product-title], h1'
  );

  return productTitleElement ? productTitleElement.textContent.trim() : '';
}

function getSelectedVariantText(variantFromEvent) {
  if (variantFromEvent && variantFromEvent !== 'Default Title') {
    return String(variantFromEvent).trim();
  }

  const optionSelectors = Array.from(document.querySelectorAll('form[action*="/cart/add"] select[name^="options"]'))
    .map((select) => select.options[select.selectedIndex]?.text?.trim())
    .filter(Boolean);

  const radioSelectors = Array.from(document.querySelectorAll('form[action*="/cart/add"] input[type="radio"][name^="options"]:checked'))
    .map((input) => input.value?.trim())
    .filter(Boolean);

  const optionValues = [...optionSelectors, ...radioSelectors];
  if (optionValues.length) {
    return optionValues.join(' / ');
  }

  const variantIdSelect = document.querySelector('form[action*="/cart/add"] select[name="id"]');
  const selectedVariantOptionText = variantIdSelect?.options?.[variantIdSelect.selectedIndex]?.text?.trim();

  if (selectedVariantOptionText && selectedVariantOptionText !== 'Default Title') {
    return selectedVariantOptionText;
  }

  return '';
}

function buildWhatsAppMessage(emoji, productTitle, variantText) {
  const messageParts = ['Hola Serena Lingerie'];

  if (emoji) {
    messageParts.push(String(emoji));
  }

  messageParts.push('quiero más información');

  if (productTitle) {
    messageParts.push(`del producto ${productTitle}`);
  }

  if (variantText) {
    messageParts.push(`(${variantText})`);
  }

  return messageParts.join(' ').replace(/\s+/g, ' ').trim();
}

function setWhatsAppLinks(url) {
  jQuery('#whatsAppFloatingButton').attr('href', url);
  jQuery('.btn-whatsapp').attr('href', url);
  jQuery('.btn-container-whatsapp a').attr('href', url);
}

window.addEventListener("load", async function () {

    let selectedNumber = ' +573143826515';
    const whatsAppMessageUrl = `https://api.whatsapp.com/send?phone=${selectedNumber}&text=`;

    fetch('//serenalingerie.co/cdn/shop/t/5/assets/emojis.json?v=165488091288517641271785625834')
    .then((response) => response.json())
    .then((data) => {

      let whatsAppBaseMessage = "";
      const whatsAppDispatcherValues = data;
      const whatsAppOrganicValues = data.organic;
      let whatsAppEmoji = whatsAppDispatcherValues.direct || '';
      const whatsAppFloatingButton = document.getElementById("whatsAppFloatingButton");
      let variantFromEvent = '';
      
      // get referrer
      const getReferrer = document.referrer;

      // get query params
      const locationHref = window.location.href;
      const queryString = window.location.search.substring(1);
      const urlParams = new URLSearchParams(queryString);
      let utm_source = urlParams.get("utm_source");
      let utm_medium = urlParams.get("utm_medium");

      // get product / landing data
      const productTitle = getShopifyProductTitle();

    
    !sessionStorage.getItem("locationHref") && sessionStorage.setItem("locationHref", locationHref);
    utm_source && sessionStorage.setItem("utm_source", utm_source);
    utm_medium && sessionStorage.setItem("utm_medium", utm_medium);

    if(utm_source == null) utm_source = sessionStorage.getItem("utm_source");
    if(utm_medium == null) utm_medium = sessionStorage.getItem("utm_medium");

    if (!!utm_source && !!utm_medium) {  
            
        whatsAppEmoji = data.utms.filter((item) => {
          return (
            item.utm_source.toLowerCase().trim() ===
                  utm_source.toLowerCase().trim() &&
              item.utm_medium.toLowerCase().trim() ===
                  utm_medium.toLowerCase().trim()
          );
        })[0];


        
          
      if (!whatsAppEmoji || whatsAppEmoji === undefined) {
          whatsAppFloatingButton.setAttribute(
          "data-source",
          `error-${utm_source}`
          );
          whatsAppFloatingButton.setAttribute(
          "data-medium",
          `error-${utm_medium}`
          );
          whatsAppFloatingButton.classList.add("error-utm");
      }


      if (whatsAppEmoji) {
        whatsAppEmoji = whatsAppEmoji.name.split("-");
      }else{
          whatsAppEmoji = whatsAppDispatcherValues.direct;
      }


    }else if (getReferrer) {
        whatsAppEmoji = whatsAppOrganicValues.filter((item) => {
        return getReferrer.toLowerCase().includes(item.source.toLowerCase());
        });
        if (!whatsAppEmoji.length) {
        whatsAppEmoji = whatsAppDispatcherValues.direct;
        } else {
        whatsAppEmoji = whatsAppEmoji[0].name.split("-");
        }
    }
  
    const updateWhatsAppUrl = () => {
      const variantText = getSelectedVariantText(variantFromEvent);
      whatsAppBaseMessage = buildWhatsAppMessage(whatsAppEmoji, productTitle, variantText);
      urlWhatsapp = `${whatsAppMessageUrl}${encodeURIComponent(whatsAppBaseMessage)}`;
      console.log(urlWhatsapp);
      setWhatsAppLinks(urlWhatsapp);
    };

    updateWhatsAppUrl();

    document.addEventListener('change', function (event) {
      const target = event.target;
      if (!target) return;

      const isVariantField =
        target.matches('form[action*="/cart/add"] select[name^="options"]') ||
        target.matches('form[action*="/cart/add"] input[type="radio"][name^="options"]') ||
        target.matches('form[action*="/cart/add"] select[name="id"]');

      if (!isVariantField) return;
      updateWhatsAppUrl();
    });

    document.addEventListener('variant:change', function (event) {
      variantFromEvent = event?.detail?.variant?.title || '';
      updateWhatsAppUrl();
    });

    jQuery('#whatsAppFloatingButton').removeClass('hide')

});
});
